// extracted by mini-css-extract-plugin
module.exports = {"container":"e_bB","up":"e_cB","down":"e_dB","percent":"e_eB","percentVal":"e_fB","title":"e_gB","tags":"e_hB","textBadge":"e_iB"};